import React from "react";
import { observer } from "mobx-react";
import { AlertRuleUpdateStore } from "../../store";
import { AlertRuleUpdateForm } from "./AlertRuleUpdateForm";
import { ErrorDialog, ConfirmCancelDialog } from "../../../../common/controls";
import { SavingOverlay } from "../../../../common/controls/forms/SavingOverlay";
import { OutdatedAfterSaveNotice } from "../../../../common/controls/forms/OutdatedAfterSaveNotice";

export type AlertRuleUpdateProps = {
  alertRuleUpdateStore: AlertRuleUpdateStore;
  showToolbox?: boolean;
  showSaveFooter?: boolean;
};

export const AlertRuleUpdate: React.FC<AlertRuleUpdateProps> = observer(
  ({ alertRuleUpdateStore, showToolbox = true, showSaveFooter }) => {
    return (
      <>
        <SavingOverlay open={alertRuleUpdateStore.isSaving} />
        <OutdatedAfterSaveNotice
          open={alertRuleUpdateStore.savedButOutdated}
          onReload={() => alertRuleUpdateStore.reloadAlertRule()}
          reloadDisabled={alertRuleUpdateStore.isProcessing}
        />
        <AlertRuleUpdateForm
          alertRuleUpdateStore={alertRuleUpdateStore}
          alertTypeError={alertRuleUpdateStore.errors.alertType?.message}
          onAlertTypeChange={(value: string) => {
            alertRuleUpdateStore.setAlertTypeValue(value);
          }}
          alertType={alertRuleUpdateStore.entityValues.alertType}
          enabledError={alertRuleUpdateStore.errors.enabled?.message}
          onEnabledChange={(value: boolean) => {
            alertRuleUpdateStore.setEnabledValue(value);
          }}
          enabled={alertRuleUpdateStore.entityValues.enabled}
          paramsError={alertRuleUpdateStore.errors.params?.message}
          onParamsChange={(value: string) => {
            alertRuleUpdateStore.setParamsValue(value);
          }}
          params={alertRuleUpdateStore.entityValues.params}
          showToolbox={showToolbox}
          showSaveFooter={showSaveFooter}
          saving={alertRuleUpdateStore.saveDisabled}
          onSave={() => alertRuleUpdateStore.saveAlertRule()}
          onCancel={() => alertRuleUpdateStore.cancelAlertRule()}
        />
        <ErrorDialog
          open={alertRuleUpdateStore.errorDialogOpened}
          title={alertRuleUpdateStore.errorTitle}
          description={alertRuleUpdateStore.errorDescription}
          onClose={() => alertRuleUpdateStore.closeErrorDialog()}
        />
        <ConfirmCancelDialog
          open={alertRuleUpdateStore.confirmDialogOpened}
          title={alertRuleUpdateStore.confirmDialogTitle}
          description={alertRuleUpdateStore.confirmDialogDescription}
          onConfirm={() => alertRuleUpdateStore.executeConfirmedAction()}
          onCancel={() => alertRuleUpdateStore.closeConfirmDialog()}
        />
      </>
    );
  }
);
